import React from 'react';
import { connect } from 'react-redux';
import ModalComponent from '../components/ModalComponent';
import { hideModal } from '../actions/modal';
import propDefs from '../proptypes';

export class HoursModalContainer extends React.Component {
	render() {
		return (
			<ModalComponent
				show={this.props.showModal}
				onHide={this.props.hideModal}
				hours={this.props.hours}
				prefs={this.props.prefs}
			/>
		);
	}
}

HoursModalContainer.defaultProps = {
	showModal: propDefs.defaults.showModal,
	hours: propDefs.defaults.hours
};

HoursModalContainer.propTypes = {
	hours: propDefs.settings.hours,
	prefs: propDefs.settings.prefs.isRequired,
	showModal: propDefs.settings.showModal,
	hideModal: propDefs.settings.hideModal.isRequired
};

const mapStateToProps = state => {
	return {
		hours: state.hours,
		prefs: state.prefs,
		modal: state.modal
	};
};

const mapDispatchToProps = dispatch => ({
	hideModal: () => {
		dispatch(hideModal());
	}
});

const HoursModal = connect(
	mapStateToProps,
	mapDispatchToProps
)(HoursModalContainer);

export default HoursModal;



// WEBPACK FOOTER //
// ./src/containers/HoursModal.jsx